var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgAddCircleWhite = function SvgAddCircleWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34.823 34.823"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "add_circle_white_svg__b",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "add_circle_white_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h34.823v34.823H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#add_circle_white_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.411 3.166a14.246 14.246 0 1 0 14.247 14.245A14.246 14.246 0 0 0 17.411 3.166m0-3.166A17.412 17.412 0 1 1 0 17.411 17.412 17.412 0 0 1 17.411 0",
    fill: "url(#add_circle_white_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.994 15.828h6.334v3.166h-6.334v6.334h-3.166v-6.334H9.497v-3.166h6.331V9.497h3.166Z",
    fill: "#fff"
  }))));
};

export default SvgAddCircleWhite;